import {useEffect, useState} from "react";
import {CustomInput} from "reactstrap";
import {useNavigate, useSearchParams} from "react-router-dom";
import WebPaths from "@router/paths/web";
import areTwoArraysEqual from "@utils/areTwoArraysEqual";
import handleFieldsData from "@utils/handleFieldsData";

import "./style.scss";

const CheckBoxFilter = ({data}) => {
    const {key, label, options} = data;
    const [searchParams, setSearchParams] = useSearchParams();
    const defaultBoxes = searchParams.getAll(key);
    const [checkedBoxes, setCheckedBoxes] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (typeof defaultBoxes !== "undefined") {
            setCheckedBoxes(defaultBoxes);
        }
    }, [searchParams]);

    useEffect(() => {
        const boxesAreEqual = areTwoArraysEqual(defaultBoxes, checkedBoxes);

        const boxesHaveChanged = !boxesAreEqual;

        if (boxesHaveChanged) {
            const delayDebounceFn = setTimeout(() => {
                addCheckedBoxesToUrl();
            }, 1000);

            return () => clearTimeout(delayDebounceFn);
        }
    }, [checkedBoxes]);

    const addCheckedBoxesToUrl = () => {
        let updatedSearchParams = new URLSearchParams(searchParams.toString());
        updatedSearchParams.delete(key);

        let temp = checkedBoxes;
        temp = temp.map(item => {
            return (
                {
                    param: key,
                    values: item
                }
            )
        });

        navigate(WebPaths.products([...temp], "?" + updatedSearchParams.toString()));
    }

    const handleCheckboxChange = (event) => {
        handleFieldsData(checkedBoxes, setCheckedBoxes, event);

        let newParamsQuery = new URLSearchParams(searchParams);
        if (newParamsQuery.get("page")) {
            newParamsQuery.delete("page")
            setSearchParams(newParamsQuery);
        }
    }

    return (
        <section className="checkbox-filter">
            <h6 className="font-weight-bolder">
                {label}
            </h6>

            <div className="d-flex flex-column">
                <div>
                    {options?.map(option =>
                        <CustomInput
                            key={option.value}
                            id={option.value}
                            type="checkbox"
                            name={option.value}
                            label={option.label}
                            checked={checkedBoxes?.includes(option.value)}
                            onChange={handleCheckboxChange}
                        />
                    )}
                </div>
            </div>
        </section>
    );
}

export default CheckBoxFilter;
